import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default1kkisaow5bg5n as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      n1q() {
        throw SerializationException().h1o(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      o1q() {
        return true;
      }
      p1q() {
        return null;
      }
      q1q() {
        var tmp = this.n1q();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      r1q() {
        var tmp = this.n1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      s1q() {
        var tmp = this.n1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      t1q() {
        var tmp = this.n1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      u1q() {
        var tmp = this.n1q();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      v1q() {
        var tmp = this.n1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      w1q() {
        var tmp = this.n1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      x1q() {
        var tmp = this.n1q();
        return tmp instanceof Char() ? tmp.e4_1 : THROW_CCE();
      }
      y1q() {
        var tmp = this.n1q();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      z1q(enumDescriptor) {
        var tmp = this.n1q();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      a1r(descriptor) {
        return this;
      }
      b1r(deserializer, previousValue) {
        return this.c1r(deserializer);
      }
      d1r(descriptor) {
        return this;
      }
      e1r(descriptor) {
      }
      f1r(descriptor, index) {
        return this.q1q();
      }
      g1r(descriptor, index) {
        return this.r1q();
      }
      h1r(descriptor, index) {
        return this.s1q();
      }
      i1r(descriptor, index) {
        return this.t1q();
      }
      j1r(descriptor, index) {
        return this.u1q();
      }
      k1r(descriptor, index) {
        return this.v1q();
      }
      l1r(descriptor, index) {
        return this.w1q();
      }
      m1r(descriptor, index) {
        return this.x1q();
      }
      n1r(descriptor, index) {
        return this.y1q();
      }
      o1r(descriptor, index) {
        return this.a1r(descriptor.p1p(index));
      }
      p1r(descriptor, index, deserializer, previousValue) {
        return this.b1r(deserializer, previousValue);
      }
      r1r(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.m1m().b1p();
        var tmp;
        if (isNullabilitySupported || this.o1q()) {
          tmp = this.b1r(deserializer, previousValue);
        } else {
          tmp = this.p1q();
        }
        return tmp;
      }
    }
    protoOf($).q1r = decodeSerializableElement$default;
    protoOf($).c1r = decodeSerializableValue;
    protoOf($).t1r = decodeSequentially;
    protoOf($).v1r = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
